import { createRoot } from 'react-dom/client';

import { FRONT_PAGES } from '@single-pages/config';
import { PageShell } from '@single-pages/ui';
import { createTextList } from '@single-pages/utils';

import '../../styles/index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('缺少应用挂载节点 #root');
}

createRoot(rootElement).render(
  <PageShell title="single-pages 项目基座" description="这里是多个独立单页应用的公共入口。">
    <ul className="space-y-2 text-sm text-slate-700">
      {createTextList(
        FRONT_PAGES.map((page) => `${page.title} - ${page.description}`),
      ).map((item) => (
        <li key={item} className="rounded-lg bg-slate-50 px-3 py-2">
          {item}
        </li>
      ))}
    </ul>
  </PageShell>,
);
